import { call, put, takeEvery } from 'redux-saga/effects'
import {
  // Store Product List
  getStoreProductListApiData,
  getStoreProductListApiSuccess,
  getStoreProductListApiFailed,
  // Store Product Item Details
  getStoreProductDetailsListApiData,
  getStoreProductDetailsListApiSuccess,
  getStoreProductDetailsListApiFailed,

  // add Product
  addStoreProductListApiData,
  addStoreProductListApiSuccess,
  addStoreProductListApiFailed,
  // Update Product
  updateStoreProductListApiData,
  updateStoreProductListApiSuccess,
  updateStoreProductListApiFailed,
  // delete Product
  deleteStoreProductListItemApiData,
  deleteStoreProductListItemApiSuccess,
  deleteStoreProductListItemApiFailed,
  // product Status Change
  productStatusChangeApiData,
  productStatusChangeApiSuccess,
  productStatusChangeApiFailed,
  // Add Bulk Product
  addBulkProductByExcelApiData,
  addBulkProductByExcelApiSuccess,
  addBulkProductByExcelApiFailed,

  // get Admin product Api
  getAdminProductListApiData,
  getAdminProductListApiSuccess,
  getAdminProductListApiFailed,

  // Get Admin product details
  getAdminProductDetailsListApiData,
  getAdminProductDetailsListApiSuccess,
  getAdminProductDetailsListApiFailed,

  // Add Admin Product
  addAdminProductListApiData,
  addAdminProductListApiSuccess,
  addAdminProductListApiFailed,

  // Update Admin Product List
  updateAdminProductListApiData,
  updateAdminProductListApiSuccess,
  updateAdminProductListApiFailed,
  //Delete Admin Product List
  deleteAdminProductListItemApiData,
  deleteAdminProductListItemApiSuccess,
  deleteAdminProductListItemApiFailed,
  // Admin product Status Change
  adminProductStatusChangeApiData,
  adminProductStatusChangeApiSuccess,
  adminProductStatusChangeApiFailed,
} from './slice'
import { API } from '../../services'

function* getStoreProductListApi({ type, payload }) {
  try {
    const response = yield call(API.otherService.getStoreProductList, payload)
    if (response.data && response.status === 200) {
      yield put(getStoreProductListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getStoreProductListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreProductListApiFailed({ message: error?.message }))
  }
}
function* getStoreProductDetailsListApi({ type, payload }) {
  try {
    const response = yield call(API.otherService.getStoreProductDetailsList, payload)
    if (response.data && response.status === 200) {
      yield put(getStoreProductDetailsListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getStoreProductDetailsListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStoreProductDetailsListApiFailed({ message: error?.message }))
  }
}
function* addStoreProductListApi({ type, payload }) {
  try {
    const response = yield call(API.otherService.addStoreProductList, payload)
    if (response.data && response.status === 200) {
      yield put(addStoreProductListApiSuccess({ payload: response?.data }))
    } else {
      yield put(addStoreProductListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addStoreProductListApiFailed({ message: error?.message }))
  }
}
function* updateStoreProductListApi({ type, payload }) {
  try {
    const response = yield call(API.otherService.updateStoreProductList, payload)
    if (response.data && response.status === 200) {
      yield put(updateStoreProductListApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateStoreProductListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateStoreProductListApiFailed({ message: error?.message }))
  }
}
function* deleteStoreProductListItemApi({ type, payload }) {
  try {
    const response = yield call(API.otherService.deleteStoreProductListItem, payload)
    if (response.data && response.status === 200) {
      yield put(deleteStoreProductListItemApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteStoreProductListItemApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteStoreProductListItemApiFailed({ message: error?.message }))
  }
}
function* productStatusChangeApi({ type, payload }) {
  try {
    const response = yield call(API.otherService.productStatusChange, payload)
    if (response.data && response.status === 200) {
      yield put(productStatusChangeApiSuccess({ payload: response?.data }))
    } else {
      yield put(productStatusChangeApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(productStatusChangeApiFailed({ message: error?.message }))
  }
}
function* addBulkProductByExcelApi({ type, payload }) {
  try {
    const response = yield call(API.otherService.addBulkProductByExcel, payload)
    if (response.data && response.status === 200) {
      yield put(addBulkProductByExcelApiSuccess({ payload: response?.data }))
    } else {
      yield put(addBulkProductByExcelApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addBulkProductByExcelApiFailed({ message: error?.message }))
  }
}
function* getAdminProductListApi({ type, payload }) {
  try {
    const response = yield call(API.otherService.getAdminProductList, payload)
    if (response.data && response.status === 200) {
      yield put(getAdminProductListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getAdminProductListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getAdminProductListApiFailed({ message: error?.message }))
  }
}
function* getAdminProductDetailsListApi({ type, payload }) {
  try {
    const response = yield call(API.otherService.getAdminProductDetailsList, payload)
    if (response.data && response.status === 200) {
      yield put(getAdminProductDetailsListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getAdminProductDetailsListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getAdminProductDetailsListApiFailed({ message: error?.message }))
  }
}
function* addAdminProductListApi({ type, payload }) {
  try {
    const response = yield call(API.otherService.addAdminProductList, payload)
    if (response.data && response.status === 200) {
      yield put(addAdminProductListApiSuccess({ payload: response?.data }))
    } else {
      yield put(addAdminProductListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addAdminProductListApiFailed({ message: error?.message }))
  }
}
function* updateAdminProductListApi({ type, payload }) {
  try {
    const response = yield call(API.otherService.updateAdminProductList, payload)
    if (response.data && response.status === 200) {
      yield put(updateAdminProductListApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateAdminProductListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateAdminProductListApiFailed({ message: error?.message }))
  }
}
function* deleteAdminProductListItemApi({ type, payload }) {
  try {
    const response = yield call(API.otherService.deleteAdminProductListItem, payload)
    if (response.data && response.status === 200) {
      yield put(deleteAdminProductListItemApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteAdminProductListItemApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteAdminProductListItemApiFailed({ message: error?.message }))
  }
}

function* adminProductStatusChangeApi({ type, payload }) {
  try {
    const response = yield call(API.otherService.adminProductStatusChange, payload)
    if (response.data && response.status === 200) {
      yield put(adminProductStatusChangeApiSuccess({ payload: response?.data }))
    } else {
      yield put(adminProductStatusChangeApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(adminProductStatusChangeApiFailed({ message: error?.message }))
  }
}

function* otherSaga() {
  yield takeEvery(getStoreProductListApiData, getStoreProductListApi)
  yield takeEvery(getStoreProductDetailsListApiData, getStoreProductDetailsListApi)
  yield takeEvery(addStoreProductListApiData, addStoreProductListApi)
  yield takeEvery(updateStoreProductListApiData, updateStoreProductListApi)
  yield takeEvery(deleteStoreProductListItemApiData, deleteStoreProductListItemApi)
  yield takeEvery(productStatusChangeApiData, productStatusChangeApi)
  yield takeEvery(addBulkProductByExcelApiData, addBulkProductByExcelApi)
  // Admin product
  yield takeEvery(getAdminProductListApiData, getAdminProductListApi)
  yield takeEvery(getAdminProductDetailsListApiData, getAdminProductDetailsListApi)
  yield takeEvery(addAdminProductListApiData, addAdminProductListApi)
  yield takeEvery(updateAdminProductListApiData, updateAdminProductListApi)
  yield takeEvery(deleteAdminProductListItemApiData, deleteAdminProductListItemApi)
  yield takeEvery(adminProductStatusChangeApiData, adminProductStatusChangeApi)
}

export default otherSaga
